export default "__VITE_ASSET__BYKQEKmD__"